export default __webpack_public_path__ + "static/careers-masthead-3446b2c09b8cf67440ba80e152727bea.png";